import { ReactNode } from 'react';
import { useLocation } from 'react-router';
import { Header, Footer } from '@/components';
import { User } from '@/shared';

export function MainLayout({
  children,
}: {
  children: ReactNode;
}) {
  const location = useLocation();
  const footerMiniMode = location && location.pathname !== '/';
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer miniMode={footerMiniMode} />
    </>
  );
}
